import { Markdown } from '@/components';
import { Show } from 'solid-js';
import { RespondForm } from './RespondForm';
import type { PollDetail } from './api';

export const PollPreview = (props: {
  poll: Pick<PollDetail, 'id' | 'fields' | 'description' | 'allowEdit'>;
}) => (
  <div>
    <p class="mb-5 rounded-lg bg-brand-50 p-3 text-sm text-brand-700 dark:bg-brand-900 dark:text-brand-200">
      Preview — try the form without submitting a response.
    </p>
    <Show when={props.poll.description}>
      <Markdown source={props.poll.description} class="mb-5" />
    </Show>
    <RespondForm
      preview
      poll={{ ...props.poll, status: 'open', myResponse: null, canViewResults: false }}
    />
  </div>
);
